/**
 * Minimal document.title manager that reads the metaInfo() component option.
 * Replaces vue-meta for this app's usage (title + titleTemplate only).
 *
 * Components declare:
 *   metaInfo() { return { title: 'Page Name' }; }
 *
 * Layout/wrapper components declare:
 *   metaInfo() { return { titleTemplate(chunk) { return `${chunk} | ${merchant.name}`; } }; }
 *
 * When a page component with title mounts or the route changes, this plugin
 * walks up the $parent chain to find the nearest titleTemplate ancestor and
 * applies it.
 */

function getComponentMeta(vm) {
  const { metaInfo } = vm.$options;
  if (!metaInfo) return null;
  return typeof metaInfo === 'function' ? metaInfo.call(vm) : metaInfo;
}

function findTitleTemplate(vm) {
  let current = vm;

  while (current) {
    const meta = getComponentMeta(current);
    if (meta && meta.titleTemplate) return meta.titleTemplate;
    current = current.$parent || null;
  }

  return null;
}

function applyMetaInfo(vm) {
  const meta = getComponentMeta(vm);
  if (!meta || !meta.title) return;

  const titleTemplate = findTitleTemplate(vm.$parent);
  document.title = titleTemplate ? titleTemplate(meta.title) : meta.title;
}

export default {
  install(app) {
    app.mixin({

      watch: {
        $route: {
          handler() {
            applyMetaInfo(this);
          }
        }
      },
      mounted() {
        applyMetaInfo(this);
      }
    });
  }
};
